const { get, getAll } = require( "PARENT/utilities/querySelector" );

document.addEventListener( 'DOMContentLoaded', init, { once: true } );

let rem = 16;

function init() {
    rem = parseInt( getComputedStyle( document.documentElement ).fontSize );
    const cards = getAll( '.card--inclusion' );

    cards.forEach( card => {
        card.classList.toggle( 'requires-more', requiresMore( card ) );
        const toggler = get( '.card-read-more', card );
        toggler?.addEventListener( 'click', toggleCard );
    } );
}

/**
 * @param {HTMLElement} card
 *
 * @return {boolean}
 */
function requiresMore( card ) {
    const content = get( '.card-content', card );
    return !!( content && ( content.clientHeight > rem * 9 ) );
}

/**
 * @param {MouseEvent} e
 *
 */
function toggleCard( e ) {
    const toggle = e.currentTarget;
    const card = toggle.closest( '.card--inclusion' );
    card.classList.toggle( 'is-open' );
    toggle.setAttribute( 'aria-expanded', card.classList.contains( 'is-open' ) );
}
